import { identity } from './state.svelte';
import { onAuthChange } from './auth';
import { getGuestIdentity } from './guest';

let attached = false;

/**
 * Arranque de identidad (M4.2).
 * 1) Lee la sesión actual (o guest si no hay).
 * 2) Engancha el watcher de cambios de auth.
 *
 * Debe llamarse una sola vez, desde main.ts, tras abrir la DB.
 */
export async function bootstrapIdentity(): Promise<void> {
  await identity.refresh();
  if (attached) return;
  attached = true;

  onAuthChange((next) => {
    if (next) {
      identity.apply(next);
      return;
    }
    identity.apply(getGuestIdentity());
  });
}

export function isIdentityReady(): boolean {
  return identity.ready;
}